// extracted by mini-css-extract-plugin
module.exports =  {"button":"_33974c2b58--button--GVLSF","dark":"_33974c2b58--dark--gen_X"};